import { render, staticRenderFns } from "./JobSearchInfinite.vue?vue&type=template&id=6c8cbb25&scoped=true&"
import script from "./JobSearchInfinite.vue?vue&type=script&lang=js&"
export * from "./JobSearchInfinite.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6c8cbb25",
  null
  
)

export default component.exports

/* nuxt-component-imports */
installComponents(component, {JobsJobCard: require('/opt/build/repo/components/Jobs/JobCard.vue').default})
